import { jsx as _jsx } from "react/jsx-runtime";
import Lottie from "lottie-react";
import animationData from "../animations/loadingAnimation.json";
export default function LottieAnimation() {
    return (_jsx("div", { children: _jsx(Lottie, { animationData: animationData }) }));
}
